import { useEffect, useState, useRef } from 'react';
import { IKeyValuePair } from '../../../utils/constants/interfaces';

const useMultiselect = (
  options: IKeyValuePair<string>[],
  selectedOptions: string[],
  onChange: (values: string[]) => void
) => {
  const componentRef = useRef<HTMLDivElement | null>(null);
  const [showOptions, setShowOptions] = useState(false);
  const [selectedValues, setSelectedValues] = useState<string[]>(selectedOptions);

  const toggleOptionDisplay = () => {
    setShowOptions((show) => !show);
  };

  const isSelected = (value: string) => selectedValues.includes(value);

  const toggleOptionSelect = (value: string) => {
    let updatedValues = [...selectedValues];
    if (updatedValues.includes(value)) {
      updatedValues = updatedValues.filter((option) => option !== value);
    } else {
      updatedValues = [...updatedValues, value];
    }
    setSelectedValues(updatedValues);
    onChange(updatedValues);
  };

  const selectAllOptions = () => {
    const values = options.map((opt) => opt.key);
    setSelectedValues(values);
    onChange(values);
  };

  const deselectAllOptions = () => {
    setSelectedValues([]);
    onChange([]);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (componentRef.current && !componentRef.current.contains(event.target as Node)) {
      setShowOptions(false);
    }
  };

  useEffect(() => {
    setSelectedValues(selectedOptions);
  }, [options, selectedOptions]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return {
    componentRef,
    showOptions,
    selectedValues,
    isSelected,
    selectAllOptions,
    deselectAllOptions,
    toggleOptionDisplay,
    toggleOptionSelect
  };
};

export default useMultiselect;
